export interface ExonerationZoneResultValueJson {
  result: string | null;
  start_date: string | null;
  end_date: string | null;
}

export interface ExonerationZoneResultJson {
  zafr: ExonerationZoneResultValueJson | null;
  qppv: ExonerationZoneResultValueJson | null;
  zfu: ExonerationZoneResultValueJson | null;
  zrr: ExonerationZoneResultValueJson | null;
  zfrr: ExonerationZoneResultValueJson | null;
  ber: ExonerationZoneResultValueJson | null;
  zrd: ExonerationZoneResultValueJson | null;
  bud: ExonerationZoneResultValueJson | null;
  zdp: ExonerationZoneResultValueJson | null;
  zrcv: ExonerationZoneResultValueJson | null;
  zorcomir: ExonerationZoneResultValueJson | null;
}

export class ExonerationZoneResultValue {
  constructor(
    public result: string | null = null,
    public startDate: string | null = null,
    public endDate: string | null = null
  ) {}

  static fromJson(json: ExonerationZoneResultValueJson): ExonerationZoneResultValue {
    return new ExonerationZoneResultValue(json?.result ?? null, json?.start_date ?? null, json?.end_date ?? null);
  }
}

export class ExonerationZoneResult {
  constructor(
    public zafr: ExonerationZoneResultValue = new ExonerationZoneResultValue(),
    public qppv: ExonerationZoneResultValue = new ExonerationZoneResultValue(),
    public zfu: ExonerationZoneResultValue = new ExonerationZoneResultValue(),
    public zrr: ExonerationZoneResultValue = new ExonerationZoneResultValue(),
    public zfrr: ExonerationZoneResultValue = new ExonerationZoneResultValue(),
    public ber: ExonerationZoneResultValue = new ExonerationZoneResultValue(),
    public zrd: ExonerationZoneResultValue = new ExonerationZoneResultValue(),
    public bud: ExonerationZoneResultValue = new ExonerationZoneResultValue(),
    public zdp: ExonerationZoneResultValue = new ExonerationZoneResultValue(),
    public zrcv: ExonerationZoneResultValue = new ExonerationZoneResultValue(),
    public zorcomir: ExonerationZoneResultValue = new ExonerationZoneResultValue()
  ) {}

  static fromJson(json: ExonerationZoneResultJson): ExonerationZoneResult {
    return new ExonerationZoneResult(
      ExonerationZoneResultValue.fromJson(json.zafr),
      ExonerationZoneResultValue.fromJson(json.qppv),
      ExonerationZoneResultValue.fromJson(json.zfu),
      ExonerationZoneResultValue.fromJson(json.zrr),
      ExonerationZoneResultValue.fromJson(json.zfrr),
      ExonerationZoneResultValue.fromJson(json.ber),
      ExonerationZoneResultValue.fromJson(json.zrd),
      ExonerationZoneResultValue.fromJson(json.bud),
      ExonerationZoneResultValue.fromJson(json.zdp),
      ExonerationZoneResultValue.fromJson(json.zrcv),
      ExonerationZoneResultValue.fromJson(json.zorcomir)
    );
  }
}
